import AllRoutes from "./Routes/AllRoutes";
import {AspectRatio} from "@chakra-ui/react"


function App() {
  return (
    <div className="App">
    <AllRoutes/>
    
    </div>
  );
}

export default App;
